import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function TruthSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-32 px-6 bg-dark-bg relative" data-id="element-171">
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-172">
        <div className="w-px h-24 bg-gradient-to-b from-transparent via-accent/30 to-transparent" data-id="element-173" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-4 mb-10" data-id="element-175">
          <p className="text-2xl md:text-4xl font-serif font-bold text-text-primary" data-id="element-176">
            La diferencia no es talento.
          </p>
          <p className="text-2xl md:text-4xl font-serif font-bold text-text-primary" data-id="element-177">
            No es suerte.
          </p>
          <p className="text-2xl md:text-4xl font-serif font-bold text-accent" data-id="element-178">
            Es tener un sistema claro.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-xl md:text-2xl text-text-secondary" data-id="element-179">
          Y eso es exactamente lo que vas a aprender aquí.
        </motion.p>
      </div>
    </section>;
}